import { LandingBlock, LandingBlockProps } from '../LandingBlock/LandingBlock';
import styles from './LandingReviews.module.scss';
import { Heading } from '../../Heading/Heading';
import { DrJessicaReviews } from './Reviews';
import { ReviewCard } from './ReviewCard/ReviewCard';

interface LandingReviewProps extends Omit<LandingBlockProps, 'documentTitle'> {}

export const LandingReviews = ({ ...props }: LandingReviewProps) => {
  const renderReviews = () =>
    DrJessicaReviews.map((review, index) => (
      <ReviewCard key={review.review} {...review} index={index} />
    ));

  return (
    <LandingBlock {...props} documentTitle="Reviews" classname={styles.root}>
      <div className={styles.content}>
        <div className={styles.header}>
          <span className={styles.eyebrow}>Patient experiences</span>
          <Heading className={styles.title} headingLevel="h2">
            Care that people remember
          </Heading>
          <p className={styles.subtitle}>
            A closer look at patient notes from people who trusted Dr. Jessica
            Flores for attentive, personal medical care.
          </p>
        </div>
        <ul className={styles.container}>{renderReviews()}</ul>
      </div>
    </LandingBlock>
  );
};
